/**
 * Shared "prefers-reduced-motion" gate for the render layer (WCAG 2.3.3). Unlike a one-shot
 * `matchMedia(...).matches` read at import time, this REACTS to the user toggling the OS setting
 * mid-session: a single shared MediaQueryList with a `change` listener keeps a cached boolean in sync.
 *
 * Reads are allocation-free and cheap (just returns the cached bool) — safe to call every frame from
 * every animated node (ducks, ambient atmosphere). SSR / no-`matchMedia` environments degrade to
 * `false` (full motion, the sensible default when we can't know the preference).
 */

const QUERY = '(prefers-reduced-motion: reduce)';

let reduced = false;

if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const mql = window.matchMedia(QUERY);
  reduced = mql.matches;
  // Keep the cached value in sync if the user flips the OS setting after load.
  mql.addEventListener('change', (e) => {
    reduced = e.matches;
  });
}

/** Cheap, allocation-free read of the live reduced-motion preference (reactive to OS changes). */
export function isReducedMotion(): boolean {
  return reduced;
}
